const urlName = '/usercenter/v1/user'

export default API => ({
    
// 获取学员信息
getUserInfo(pageNum,pageSize,data) {
    return API({
        url: `${urlName}/getUserInfo` ,
        data
    });
},
// 学员管理
getStudentList(pageNum,pageSize,data) {
    return API({
        url: `${urlName}/findByCondition?pageSize=${pageSize}&pageNum=${pageNum}` ,
        method:  'post',
        data
    });
},
// 添加学员
addStudent(data) {
    return API({
        url: `${urlName}/addStudent` ,
        method:  'post',
        data
    });
},
// 修改
saveStudent(userId,data){
    return API({
        url: `${urlName}/updateStudent?userId=${userId}` ,
        method:  'post',
        data
    });
},
// 删除

deleteStudent(userId) {
    return API({
        url: `${urlName}/delete?userId=${userId}` ,
        method:  'get',
    });
},
})